export const state = () => ({
  isOpenNavBar: true,
})

export const mutations = {
  toggleNavBar(state) {
    state.isOpenNavBar = !state.isOpenNavBar
  },
  openNavBar(state) {
    state.isOpenNavBar = true
  },
  closeNavBar(state) {
    state.isOpenNavBar = false
  },
}
